import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CssBaseline,
  Stack,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import { ArrowForwardIosRounded } from "@mui/icons-material";
import * as React from "react";
import { useState } from "react";
import SnapSlider from "./SnapSlider";
import { useTranslation, I18nextProvider } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Calculate from "../modals/Calculate";

const defaultTheme = createTheme({
  typography: {
    fontFamily: '"Kanit", "Roboto", sans-serif',
    fontSize: 16,
  },
  palette: {
    primary: {
      main: "#007FFF",
      dark: "#0066CC",
    },
  },
});
function MainRouting({ screenWidth }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [openCalculate, setOpenCalculate] = useState(false)

  // ให้แน่ใจว่า districts เป็น Array
  const districtsRaw = t("districts", { returnObjects: true });
  const districts = Array.isArray(districtsRaw) ? districtsRaw : [];
  const menuItems = districts?.map((item) => ({
    id: item.id,
    label: i18n.language === "th" ? item.name_th : item.name_en,
    type: "button",
    icon: item?.icon,
  }));



  const handleOpenCalculate = () => {
    setOpenCalculate(true)
  }
  const handleOpenCalculateOfEntrepreneurs = () => {
    window.open('https://drive.google.com/drive/folders/1FzoudFQdc-_N0Xri8stf54_4MHFUfZs0', '_blank');
  }

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={defaultTheme}>
        <CssBaseline />
        <Box
          sx={{
            borderRadius: 2,
            color: "black",
            fontSize: { xs: "0.8rem", sm: "1rem" }, // ปรับขนาดตัวอักษรให้เล็กลงสำหรับมือถือ
            display: "flex",
            width: "100%",
            minWidth: 0, // เป็น flex item ใน MainPage — ไม่ให้สไลด์ยาวๆ ดันความกว้างเกินจอ
            flexDirection: "column", // ✅ เรียงแนวตั้ง
            gap: 2, // เพิ่มระยะห่างระหว่าง item ในแนวตั้ง
          }}
        >
          {/* ปุ่มหลัก 2 ปุ่ม: การ์ดสีขาวมีไอคอน + ลูกศร */}
          <Box
            sx={{
              width: "100%",
              maxWidth: 960,
              mx: "auto",
              mt: { xs: 3, sm: 5 },
              px: { xs: 2, sm: 4 },
              boxSizing: "border-box",
              minWidth: 0, // กันข้อความยาวดันให้กล่องกว้างเกินจอ
            }}
          >
            <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 1.5, sm: 2.5 }} alignItems="stretch">
              {[
                { img: "/calculate.jpg", label: t("calculate_carbon_footprint"), onClick: handleOpenCalculate },
                { img: "/map.png", label: t("calculate_carbon_footprint_business"), onClick: handleOpenCalculateOfEntrepreneurs },
              ].map((b) => (
                <Button
                  key={b.img}
                  fullWidth
                  onClick={b.onClick}
                  sx={{
                    justifyContent: "flex-start",
                    textAlign: "left",
                    textTransform: "none",
                    whiteSpace: "normal",
                    minWidth: 0,
                    gap: 1.5,
                    px: { xs: 1.75, sm: 2.5 },
                    py: { xs: 1.5, sm: 2 },
                    borderRadius: 4,
                    color: "#1b1b1b",
                    fontWeight: 600,
                    fontSize: { xs: "0.95rem", sm: "1.05rem" },
                    lineHeight: 1.4,
                    bgcolor: "rgba(255,255,255,0.92)",
                    backdropFilter: "blur(6px)",
                    border: "1px solid rgba(46,125,50,0.15)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                    transition: "all 0.25s ease",
                    "& .go-arrow": { transition: "transform 0.25s ease" },
                    "&:hover": {
                      bgcolor: "#2e7d32",
                      color: "white",
                      transform: "translateY(-3px)",
                      boxShadow: "0 12px 28px rgba(46,125,50,0.35)",
                      "& .go-arrow": { transform: "translateX(4px)" },
                    },
                  }}
                >
                  <Avatar
                    src={b.img}
                    variant="rounded"
                    sx={{ width: { xs: 40, sm: 52 }, height: { xs: 40, sm: 52 }, bgcolor: "white", borderRadius: 2.5, p: 0.5, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                  />
                  <Box component="span" sx={{ flexGrow: 1, minWidth: 0, overflowWrap: "anywhere" }}>{b.label}</Box>
                  <ArrowForwardIosRounded className="go-arrow" sx={{ fontSize: 16, opacity: 0.7 }} />
                </Button>
              ))}
            </Stack>
          </Box>

          {/* หัวข้อ ROUTING */}
          <Box sx={{ textAlign: "center", mt: { xs: 3, sm: 5 } }}>
            <Typography
              sx={{
                fontSize: { xs: "28px", sm: "40px", md: "64px" },
                fontWeight: 800,
                letterSpacing: { xs: "0.3em", md: "0.35em" },
                pl: { xs: "0.3em", md: "0.35em" }, // ชดเชย letter-spacing ตัวสุดท้ายให้อยู่กึ่งกลางจริง
                lineHeight: 1.1,
                color: "#77B349",
                textShadow: "0 2px 12px rgba(255,255,255,0.6)",
              }}
            >
              ROUTING
            </Typography>
            <Box sx={{ width: 56, height: 4, borderRadius: 2, bgcolor: "#77B349", mx: "auto", mt: 1.5, opacity: 0.8 }} />
          </Box>
          {/* Card */}
          <Box
            sx={{
              maxWidth: { xs: "100%", sm: "80%" },
              mx: "auto",
              px: { xs: 0, sm: 4 },
              py: { xs: 2, sm: 4 },
              borderRadius: 2,
            }}
          >
            {/* มือถือ: สไลด์แนวนอน / แท็บเล็ต-เดสก์ท็อป: grid 2-3 คอลัมน์ */}
            <SnapSlider>
              {menuItems?.map((item, index) => (
                  <Card
                    key={index}
                    onClick={() => navigate(`/district/${item.id}`)}
                    sx={{
                      borderRadius: 7,
                      // transition: '0.3s',
                      maxWidth: { xs: "none", sm: "300px" }, // มือถือ: เต็มช่องสไลด์
                      width: "100%",
                      cursor: "pointer",

                      "&:hover": {
                        boxShadow: 6,
                        transform: "scale(1.03)",
                        backgroundColor: "#006400",
                        // 👉 ทำให้ปุ่มเปลี่ยนสีเมื่อ hover ที่ Card
                        "& .card-button": {
                          color: "white",
                        },
                      },
                    }}
                  >
                    <CardContent sx={{ p: 0 }}>
                      <Box
                        component="img"
                        src={`/${item?.icon}`}
                        alt={item?.label}
                        sx={{
                          width: "100%",
                          height: { xs: 160, sm: 200 }, // ปรับความสูงตามหน้าจอ
                          objectFit: "cover",
                          borderTopLeftRadius: 28,
                          borderTopRightRadius: 28,
                        }}
                      />
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                      <Typography
                        className="card-button" // ใช้ class เพื่อให้ควบคุมจาก Card
                        sx={{
                          width: "100%",
                          justifyContent: "center",
                          display: "flex",
                          fontWeight: "bold",
                          fontSize: "1rem",
                          color: "black",
                          // transition: 'color 0.3s ease',
                          "&:hover": {
                            backgroundColor: "#006400",
                          },
                        }}
                      >
                        {item?.label}
                      </Typography>
                    </CardActions>
                  </Card>
              ))}
            </SnapSlider>
          </Box>
        </Box>
      </ThemeProvider>
      {
        openCalculate && (
          <Calculate
            open={openCalculate}
            close={setOpenCalculate}
          />
        )
      }
    </I18nextProvider>
  );
}

export default MainRouting;
